import { keys } from "./Keys";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { useQuery } from "react-query";
import { IEditDTO } from "../../services/alarm-scheme-data-service/Models";
import AlarmSchemeAdministrationDataService from "../../services/alarm-scheme-data-service/AlarmSchemeAdministrationService";

export type UseGetAlarmSchemeParams = {
    organizationID: number,
    groupID: number,
    alarmSchemeID: number,
} & BaseUseQueryParameters<IEditDTO | undefined>;

export function useGetAlarmScheme({
    organizationID,
    groupID,
    alarmSchemeID,
    enabled,    
    onSuccess,
    onError
}: UseGetAlarmSchemeParams) {
    return useQuery<IEditDTO, RestError>(
        keys.getAlarmScheme(organizationID, groupID, alarmSchemeID),
        ({ signal }) => {
            return AlarmSchemeAdministrationDataService.getAlarmScheme(
                organizationID,
                groupID,
                alarmSchemeID,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            //refetchInterval: refreshSeconds ? refreshSeconds * 1000 : false,
            refetchInterval: false,
            //staleTime: 0,
            staleTime: Infinity,
            refetchOnWindowFocus: false,
            refetchOnMount: true,
            refetchOnReconnect: false,
            retry: false,
        }
    );
}